var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AbstractModalContentComponent } from '../../common/modal/abstract-modal-content.component';
import { ModalService } from '../../common/modal/modal.indra.service';
var INDRAAncillaryDiscardModalComponent = /** @class */ (function (_super) {
    __extends(INDRAAncillaryDiscardModalComponent, _super);
    function INDRAAncillaryDiscardModalComponent(modalService, router) {
        var _this = _super.call(this, modalService) || this;
        _this.modalService = modalService;
        _this.router = router;
        _this.TYPE = 'dialog';
        return _this;
    }
    INDRAAncillaryDiscardModalComponent.prototype.ngOnInit = function () {
    };
    INDRAAncillaryDiscardModalComponent.prototype.goToPayment = function () {
        var booking = this.data[1];
        this.closeModal();
        window.scrollTo(0, 0);
        this.router.navigate(['my-bookings/purchase', booking.pnr]);
    };
    INDRAAncillaryDiscardModalComponent.prototype.discardExtras = function () {
        var option = this.data[0];
        var booking = this.data[1];
        this.closeModal();
        // Reset all extras
        booking.flights.forEach(function (flight) {
            return flight.passengerInfo.forEach(function (pass) {
                var newInfo = {
                    boughtSeat: null,
                    added_bags: [],
                    loungeEnabled: false,
                    fastTrackEnabled: false,
                    specialMeals: null,
                    sportsEquipment: [],
                    pets: [],
                    musicInstruments: []
                };
                var stops = pass.stops.map(function (info) { return Object.assign({}, info, newInfo); });
            });
        });
        this.router.navigate([option.link], {
            queryParams: option.queryParams
        });
    };
    return INDRAAncillaryDiscardModalComponent;
}(AbstractModalContentComponent));
export { INDRAAncillaryDiscardModalComponent };
